<template>
  <div :class="iFrameClass">
    <Loading v-if="authStatus.isRunning" />
    <LoggedIn v-if="isAuthenticated"/>
    <div v-else class="section__form section__signup">
      <SignupForm />
      <div class="btn__group">
        <AuthWithGoogle />
        <AuthWithApple />
      </div>
      <FooterInfo :isSignup="true"/>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/elements/Loading';
import LoggedIn from '@/components/LoggedIn';
import SignupForm from '@/components/authentication/SignupForm';
import AuthWithGoogle from '@/components/authentication/AuthWithGoogle';
import AuthWithApple from '@/components/authentication/AuthWithApple';
import FooterInfo from '@/components/elements/FooterInfo';
import ThirdPartyAuthInit from '@/helpers/ThirdPartyAuthInit';
import { writeCookie } from '@/helpers/helpers';
import { capture as captureAttribution } from '@/helpers/Attribution';

import { mapGetters } from 'vuex';
import { updateAuthStatus } from '@/helpers/StoreActions';
import { getUrlVars } from '@/helpers/helpersUsingStore';

export default {
  name: "Signup",
  data: function() {
    return {
    };
  },
  components: {
    Loading,
    LoggedIn,
    SignupForm,
    AuthWithGoogle,
    AuthWithApple,
    FooterInfo
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'iFrameParentUrl',
      'iFrameClass',
      'authStatus'
    ])
  },
  created() {
    // PAE-2465: first-touch campaign context from the parent page's URL when framed.
    captureAttribution(this.iFrameParentUrl);
    updateAuthStatus({});
    if(!this.isAuthenticated) {
      ThirdPartyAuthInit();

      if(this.$route.query.campaign) {
        writeCookie('campaign', this.$route.query.campaign, 1);
      }

      if(this.iFrameParentUrl) {

        if(getUrlVars('_src')) {
          writeCookie('_src', getUrlVars('_src'), 1);
        }

        if(getUrlVars('referralCode')) {
          writeCookie('referralCode', getUrlVars('referralCode'), 1);
        }

        if(getUrlVars('abTest')) {
          writeCookie('abTest', getUrlVars('abTest'), 1);
        }
      }
    }
  },
}
</script>

<style lang="sass">
.form--simple {
  .section__form {
    min-height: 762px;
    min-width: 448px;
    padding: 15px;
    justify-content: center;
    align-items: center;
  }

  .simple-form--hidden {
    display: none;
  }

}

.simple-form--short-field {
    display: inline-block;
    width: 48%;
    vertical-align: top;

    &:nth-of-type(odd) {
      margin-right: 4%;
    }

    .error-message {
      padding: 10px 10px 10px 35px;

      &:before {
        left: 5px;
      }
    }
  }

.btn__group {
  display: flex;
  gap: 16px;
  margin-top: 16px;
  width: 100%;
  height: 46px;
}

.btn__group .btn-container {
  width: 100%;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
</style>